/**
 * PLACEHOLDERS are used to map history logs to the desired translations in the front end for titles and values
 *
 * For example:
 * History logs from BE: "<ElectricalFeedType></b> <field_updated_with> <b><twoPhase></b> <field_updated> <b><threePhase></b>" is translated to
 * "Electrical feed in is with two-phase was upated to three-phase" or "Netzeinspeisung erfolgt mit 2-phasig wurde aktualisiert auf 3-phasig" base on the translation settings in FE
 */
export const PLACEHOLDERS = {
  '<ElectricalFeedType>': 'grid-comp.feed-in-type',
  '<field_created>': 'grid-comp.field-created',
  '<field_deleted>': 'grid-comp.field-deleted',
  '<field_updated_with>': 'grid-comp.field-updated-with',
  '<field_updated>': 'grid-comp.field-updated',
  '<singlePhase>': 'grid-comp.single-phase',
  '<twoPhase>': 'grid-comp.two-phase',
  '<threePhase>': 'grid-comp.three-phase',
  '<threePhaseAcCurrent>': 'grid-comp.three-phase-ac',
  '<HasPowerStorage>': 'grid-comp.contain-storage',
  '<HasEnergyProducer>': 'grid-comp.existing-producer',
  '<City>': 'personal-data.form-details.fields.city',
  '<Street>': 'personal-data.form-details.fields.street',
  '<StreetNo>': 'personal-data.form-details.fields.street-number',
  '<AddressSuffix>': 'personal-data.form-details.fields.address-suffix',
  '<Postcode>': 'personal-data.form-details.fields.post-code',
  '<SkTitle>': 'basic-profile.fields.title',
  '<CompanyName>': 'personal-data.form-details.fields.company-name',
  '<Firstname>': 'personal-data.form-details.fields.first-name',
  '<Lastname>': 'personal-data.form-details.fields.last-name',
  '<Phone>': 'personal-data.form-details.fields.telephone',
  '<Email>': 'personal-data.form-details.fields.email',
  '<EnergyType>': 'grid-comp.producer-type',
  '<EnergySource>': 'grid-comp.source-type',
  '<OtherEnergyType>': 'grid-comp.other-producer',
  '<OtherEnergySource>': 'grid-comp.other-source',
  '<TotalFeedInPower>': 'grid-comp.existing-producer-total-power',
  '<Manufacturer>': 'grid-comp.manufacturer',
  '<Type>': 'grid-comp.type',
  '<IdenticalUnits>': 'grid-comp.number-identical-units',
  '<MaxUnitPower>': 'grid-comp.max-power-inverter-unit',
  '<BlackStartCapability>': 'grid-comp.black-start',
  '<IoPlanned>': 'grid-comp.isolated-operation',
  '<EssPlanned>': 'grid-comp.engine-supported-start',
  '<TypeOfFeedIn>': 'grid-comp.complete-feed-in',
  '<TypeOfCompleteFeedIn>': 'grid-comp.direct-feed-in',
  '<FeedInManagement>': 'grid-comp.feed-in-management',
  '<MeasuringConcept>': 'technical-data.select-concept',
  '<MeterOperation>': 'grid-comp.meter-operation',
  '<MeterOperator>': 'grid-comp.mo-done-by',
  '<TotalPowerPvModules>': 'grid-comp.pv-modules-total-power',
  '<TotalPowerInverters>': 'grid-comp.inverters-total-power',
  '<TotalPowerGenerators>': 'grid-comp.total-power-generators',
  '<IdenticalModules>': 'grid-comp.number-identical-modules',
  '<PowerSinglePvModule>': 'grid-comp.one-module-power',
  '<StorageConnection>': 'grid-comp.storage-connection',
  '<EnergyProducerConnection>': 'grid-comp.storage-connection-producer',
  '<PrimarySourcesRecordedSeparately>': 'grid-comp.storage-sources-recorded-separately',
  '<FeedInPaymentsRecordedSeparately>': 'grid-comp.storage-payments-recorded-correctly',
  '<EnergyNotSuppliedByGrid>': 'grid-comp.storage-no-grid-supplied',
  '<TotalCapacity>': 'grid-comp.storage-total-capacity',
  '<MaxDischargeCapacity>': 'grid-comp.max-discharge-capacity',
  '<NumberOfCorrespondingFigure>': 'grid-comp.storage-corresponding-figure',
  '<UsableCapacity>': 'grid-comp.storage-usable-capacity',
  '<DocumentsComment>': 'grid-comp.documents-comment',
  '<ConnectionAddressComment>': 'grid-comp.connection-address-comment',
  '<SubscriberOwnerComment>': 'grid-comp.subscriber-owner-comment',
  '<InvoiceAddressComment>': 'grid-comp.invoice-address-comment',
  '<OperatorOfPowerPlantComment>': 'grid-comp.operator-of-power-plant-comment',
  '<BaseDataComment>': 'grid-comp.base-data-comment',
  '<ExistingEnergyProducerComment>': 'grid-comp.existing-energy-producer-comment',
  '<DetailedInfoPhotovoltaicsComment>': 'grid-comp.detailed-info-photovoltaics-comment',
  '<DetailedInfoEnergyProducerComment>': 'grid-comp.detailed-info-energy-producer-comment',
  '<DetailedInfoStorageComment>': 'grid-comp.detailed-info-storage-comment',
  '<DetailedInfoGridPowerPlantComment>': 'grid-comp.detailed-info-grid-power-plant-comment',
  '<TypeOfFeedInComment>': 'grid-comp.type-of-feed-in-comment',
  '<FeedInControllabilityComment>': 'grid-comp.feed-in-controllability-comment',
  '<ConceptOfMeasurementComment>': 'grid-comp.concept-of-measurement-comment',
  '<MeterOperationComment>': 'grid-comp.meter-operation-comment',
  '<TechnicalComment>': 'facilities-data.title',
  '<CustomerNo>': 'personal-data.form-details.fields.customer-number',
  '<District>': 'personal-data.form-details.fields.district',
  '<ConUserFirstname>': 'personal-data.form-details.fields.first-name',
  '<ConUserLastname>': 'personal-data.form-details.fields.last-name',
  '<ConUserPhone>': 'personal-data.form-details.fields.telephone',
  '<OwnerIsLandlord>': 'grid-comp.grid-comp-landlord',
  '<OwnerIsPpOperator>': 'grid-comp.grid-comp-pp-operator',
  '<OwnerIsInvoiceRecepient>': 'grid-comp.grid-comp-recipient',
  '<PowerOfAttorney>': 'grid-comp.landlord-power-of-attorney',
  '<ResidentialUnitCount>': 'technician-data.form-fields.residential-units-count',
  '<ResidentialUnitNo>': 'personal-data.form-details.fields.apartment-number',
  '<Floor>': 'personal-data.form-details.fields.floor-number',
  '<NoStreetAddress>': 'personal-data.form-details.fields.street-number',
  '<BuildingAreaName>': 'personal-data.form-details.fields.building-zone',
  '<Gps>': 'personal-data.form-details.fields.gps',
  '<SectionName>': 'personal-data.form-details.fields.cadastral-section',
  '<Parcel>': 'basic-profile.jurisdiction.sws-parcel',
  '<DevelopmentArea>': 'basic-profile.jurisdiction.development-area-new',
  '<DevelopmentAreaName>': 'basic-profile.jurisdiction.development-area-name',
  '<SkDevelopmentAreaType>': 'basic-profile.jurisdiction.development-area-name',
  '<Country>': 'personal-data.form-details.fields.land',
  '<Mobile>': 'personal-data.form-details.fields.mobile',
  '<False>': 'grid-comp.no',
  '<True>': 'grid-comp.yes',
  '<GridCompTechData>': 'facilities-data.title',
  '<BusinessPartner>': 'personal-data.form-details.subscriber-title',
  '<PowerPlantOperatorAddress>': 'grid-comp.power-plant-operator',
  '<ConnectionObjectEntity>': 'personal-data.form-details.connection-address-title',
  '<DocumentUploaded>': 'grid-comp.document-uploaded',
  '<DocumentDeleted>': 'grid-comp.document-deleted',
  '<IsBaseDataLocked>': 'grid-comp.base-data-review-status',
  '<IsExistingEnergyProducerLocked>': 'grid-comp.existing-energy-producer-review-status',
  '<IsDetailedInfoPhotovoltaicsLocked>': 'grid-comp.detailed-info-photovoltaics-review-status',
  '<IsDetailedInfoEnergyProducerLocked>': 'grid-comp.detailed-info-energy-producer-review-status',
  '<IsDetailedInfoStorageLocked>': 'grid-comp.detailed-info-storage-review-status',
  '<IsDetailedInfoGridPowerPlantLocked>': 'grid-comp.detailed-info-grid-power-plant-review-status',
  '<IsTypeOfFeedInLocked>': 'grid-comp.type-of-feed-review-status',
  '<IsFeedInControllabilityLocked>': 'grid-comp.feed-in-controllability-review-status',
  '<IsConceptOfMeasurementLocked>': 'grid-comp.concept-of-measurement-review-status',
  '<IsMeterOperationLocked>': 'grid-comp.meter-operation-review-status',
  '<IsConnectionAddressLocked>': 'grid-comp.connection-address-review-status',
  '<IsSubscriberOwnerLocked>': 'grid-comp.subscriber-owner-review-status',
  '<IsInvoiceAddressLocked>': 'grid-comp.invoice-address-review-status',
  '<IsOperatorOfPowerPlantLocked>': 'grid-comp.operator-of-power-plant-review-status',
  '<IsProvisioningOfCurrentTransformersLocked>': 'grid-comp.provisioning-of-current-transformers-review-status',
  '<OK>': 'grid-comp.ok',
  '<NOT_OK>': 'grid-comp.not-ok',
  '<IsDocumentsLocked>': 'grid-comp.documents-upload-review-status',
  '<completeFeedIn>': 'grid-comp.complete-feed-in',
  '<directFeedIn>': 'grid-comp.direct-feed-in',
  '<clientOwnedPowerPlant>': 'grid-comp.financial-clearing',
  '<excessFeedIn>': 'grid-comp.excess-feed-in',
  '<AC>': 'grid-comp.ac-gekoppelt',
  '<DC>': 'grid-comp.dc',
  '<three-phase>': 'grid-comp.storage-three-phase',
  '<controlAndDemand>': 'grid-comp.control-and-demand',
  '<controlEEG>': 'grid-comp.control-according',
  '<noManagement>': 'grid-comp.no-feed-in',
  '<localOperator>': 'grid-comp.mo-local-operator',
  '<externalOperator>': 'grid-comp.mo-done-by',
  '<AreaFieldFieldSector>': 'grid-comp.area-field-field-sector',
  '<ConnectionAddress>': 'personal-data.form-details.connection-address-title',
  '<InvoiceAddress>': 'personal-data.form-details.invoice-address-title',
  '<other>': 'lookup.sk_document_type.options.other.name',
  '<site_plan>': 'lookup.sk_document_type.options.site_plan.name',
  '<floor_plan>': 'lookup.sk_document_type.options.floor_plan.name',
  '<unit_certificate>': 'lookup.sk_document_type.options.unit_certificate.name',
  '<na_protection_certificate>': 'lookup.sk_document_type.options.na_protection_certificate.name',
  '<vde_documents>': 'lookup.sk_document_type.options.vde_documents.name',
  '<data_sheet_modules>': 'lookup.sk_document_type.options.data_sheet_modules.name',
  '<data_sheet_generating_unit>': 'lookup.sk_document_type.options.data_sheet_generating_unit.name',
  '<overview_plan_single_pole>': 'lookup.sk_document_type.options.overview_plan_single_pole.name',
  '<offer>': 'lookup.sk_document_type.options.offer.name',
  '<order>': 'lookup.sk_document_type.options.order.name',
  '<invoice>': 'lookup.sk_document_type.options.invoice.name',
  '<pole_circuit_diagram_1>': 'lookup.sk_document_type.options.pole_circuit_diagram_1.name',
  '<power_of_attorney>': 'lookup.sk_document_type.options.power_of_attorney_1.name',
  '<audit_report>': 'grid-comp.converter-audit-report',
  '<circuit_diagram>': 'grid-comp.overview-circuit',
  '<integrated_grid_protection_certificate>': 'grid-comp.certificate-integrated-gp',
  '<integrated_grid_protection_audit>': 'grid-comp.audit-integrated-gp',
  '<central_grid_protection_certificate>': 'grid-comp.certificate-central-gp',
  '<central_grid_protection_audit>': 'grid-comp.audit-central-gp',
  '<drinking_water_registration>': 'lookup.sk_document_type.options.drinking_water_registration.name',
  '<ordonance_clearence>': 'lookup.sk_document_type.options.ordonance_clearence.name',
  '<excerpt_or_overview_plan>': 'lookup.sk_document_type.options.excerpt_or_overview_plan.name',
  '<assessment_of_grid>': 'grid-comp.result.assessment-of-grid-document',
  '<feed_in_controllability_contract>': 'regep.feed-in-controllability-contract',
  '<photo_documentation_of_installed_generators_and_converters>':
    'regep.commissioning-of-energy-producer.photo-documentation-of-installed-generators-and-converters',
  '<request_for_meter_mounting>': 'regep.commissioning-of-energy-producer.request-for-meter-mounting',
  '<bafa_notice_of_authorization>': 'regep.energy-producers-authorization.bafa-notice-document',
  '<list_of_data_points>': 'regep.list-of-data-points',
  '<e_1_application>': 'lookup.sk_document_type.options.e_1_application.name',
  '<e_2_data_sheet>': 'lookup.sk_document_type.options.e_2_data_sheet.name',
  '<e_3_memory_data>': 'lookup.sk_document_type.options.e_3_memory_data.name',
  '<e_4_uniform_certificate>': 'lookup.sk_document_type.options.e_4_uniform_certificate.name',
  '<e_6_certificate_for_network>': 'lookup.sk_document_type.options.e_6_certificate_for_network.name',
  '<e_7_requirements_for_test_report>': 'lookup.sk_document_type.options.e_7_requirements_for_test_report.name',
  '<b_11_overview_circuit_diagram>': 'lookup.sk_document_type.options.b_11_overview_circuit_diagram.name',
  '<registration_for_network_connection>': 'lookup.sk_document_type.options.registration_for_network_connection.name',
  '<site_plan_or_area_map>': 'lookup.sk_document_type.options.site_plan_or_area_map.name',
  '<proof_of_conformity_certificates_modules>': 'lookup.sk_document_type.options.proof_of_conformity_certificates_modules.name',
  '<proof_of_conformity_certificates_storage>': 'lookup.sk_document_type.options.proof_of_conformity_certificates_storage.name',
  '<measuring_concept>': 'lookup.sk_document_type.options.measuring_concept.name',
  '<e_5_test_report>': 'lookup.sk_document_type.options.e_5_test_report.name',
  '<e_8_commissioning_protocol>': 'lookup.sk_document_type.options.e_8_commissioning_protocol.name',
  '<ground_protocol>': 'lookup.sk_document_type.options.ground_protocol.name',
  '<power_of_attorney_1>': 'lookup.sk_document_type.options.power_of_attorney_1.name',
  '<IsWaiverOfFeedInCompensationLocked>': 'regep.WaiverOfFeedInCompensationReview',
  '<IsModelsForFeedInCompensationLocked>': 'regep.ModelsForFeedInCompensationReview',
  '<IsBankAccountDetailsLocked>': 'regep.BankAccountDetailsReview',
  '<IsDeclarationOnVatPaymentLocked>': 'regep.DeclarationOnVatPaymentReview',
  '<IsMarktstammdatenregisterRegistrationLocked>': 'regep.MarktstammdatenregisterRegistrationReview',
  '<IsCommissioningOfEnergyProducerLocked>': 'regep.CommissioningOfEnergyProducerReview',
  '<RegistrationOfEnergyProducerTechData>': 'app.navigation.tech_data',
  '<WaiverOfFeedInCompensationComment>': 'regep.WaiverOfFeedInCompensationComment',
  '<ModelsForFeedInCompensationComment>': 'regep.ModelsForFeedInCompensationComment',
  '<BankAccountDetailsComment>': 'regep.BankAccountDetailsComment',
  '<DeclarationOnVatPaymentComment>': 'regep.DeclarationOnVatPaymentComment',
  '<MarktstammdatenregisterRegistrationComment>': 'regep.MarktstammdatenregisterRegistrationComment',
  '<IsWaiverCompensation>': 'regep.waiver-feed-in-compensation.waive-compensation',
  '<CompensationModel>': 'regep.models-feed-in-compensation.title',
  '<BankAccountHolder>': 'regep.bank-account-details.account-holder',
  '<BankName>': 'regep.bank-account-details.bank',
  '<BankIban>': 'regep.bank-account-details.iban',
  '<BankBic>': 'regep.bank-account-details.bic',
  '<DueInvoice>': 'regep.bank-account-details.invoice-process-due',
  '<CreditInvoice>': 'regep.bank-account-details.invoice-process-credit',
  '<IsPaymentWithVat>': 'regep.tax-payment-declaration.title',
  '<TaxOffice>': 'regep.tax-payment-declaration.tax-office',
  '<TaxId>': 'regep.tax-payment-declaration.tax-id',
  '<MasterId>': 'regep.eeg-energy-producers.master-id',
  '<CommissioningOfEnergyProducerComment>': 'regep.CommissioningOfEnergyProducerComment',
  '<ConfirmedProvisioningDate>': 'regep.confirmed-date-for-provisioning',
};
